import { useNavigate, useLocation } from "react-router-dom";
/**
 * Custom hook that wraps React Router's `navigate` function
 * and automatically preserves the current URL's search params
 * (query string) across navigations.
 *
 * Useful when you want to retain things like `?sku=abc` or `?ref=123`
 * while navigating to a new path.
 */
export function useNavigatePreserveSearch() {
    const navigate = useNavigate();
    const { search } = useLocation();
    const navigateWithSearch = (to, options = {}) => {
        var _a;
        const path = typeof to === "string" ? `${to}${search}` : Object.assign(Object.assign({}, to), { search: (_a = to.search) !== null && _a !== void 0 ? _a : search });
        navigate(path, options);
    };
    return navigateWithSearch;
}
